import { Chip } from "@nextui-org/react";
import { ComponentPropsWithoutRef, FC, ReactNode } from "react";

export type ZChipColorValues = "green" | "yellow" | "red"

type ChipProps = {
  children: ReactNode;
  color: ZChipColorValues;
} & ComponentPropsWithoutRef<typeof Chip>;

const COLOR_CLASSES: Record<ChipProps["color"], string> = {
  green: "bg-[#D1F4E0] text-[#45D483]",
  yellow: "bg-[#FDEDD3] text-[#F5A524]",
  red: "bg-[#FDD0DF] text-[#F31260]",
};

const ZChip: FC<ChipProps> = ({ children, color, ...rest }) => {
  return (
    <Chip
      className={`rounded-full px-3 py-1 font-semibold ${COLOR_CLASSES[color] ?? "bg-gray-200 text-gray-700"}`}
      size="sm"
      {...rest}
    >
      {children}
    </Chip>
  );
};

export default ZChip;
